import React, { useEffect, useState } from 'react';
import { NavLink, Route, Routes, useLocation } from 'react-router-dom';
import { Button as AntButton, Drawer, Layout, Menu, Space, Typography } from "antd";
import { HomeOutlined, MenuOutlined } from "@ant-design/icons";
import LoginApp from "./login";
import Signup from "./component/signup";
import Main from "./component/main/main";
import Hub from "./component/hub";
import GameHub from "./component/hub/game";
import HiddenHub from "./component/hub/hidden";
import TopRanker from "./component/bser/top_ranker";
import EstherStat from "./component/bser/esther";
import EstherIndividualStat from "./component/bser/esther/individual";
import CharacterStats from "./component/bser/character_stats";
import RouteDetail from "./component/bser/route_detail";
import TeamComp from "./component/bser/team_comp";
import DamageCalculator from "./component/bser/damage_calculator";
import LiveAssist from "./component/bser/live_assist";
import LostArkParty from "./component/lostark/party";
import LostArkSchedule from "./component/lostark/schedule";
import BlogListPage from "./component/blog";
import BlogPostPage from "./component/blog/BlogPostPage";
import './App.css'

function PcMenu() {
  const location = useLocation();
  return (
    <Menu
      mode="horizontal"
      selectedKeys={[location.pathname]}
      style={{ lineHeight: '62px', borderBottom: 'none', flexGrow: 1 }}
      theme="light"
    >
      <Menu.SubMenu key="bser-group" title="통계">
        <Menu.Item key="/bser-top-ranker">
          <NavLink to={"/bser-top-ranker"}>Top Ranker</NavLink>
        </Menu.Item>
        <Menu.Item key="/bser-team-comp">
          <NavLink to={"/bser-team-comp"}>팀 조합</NavLink>
        </Menu.Item>
        <Menu.Item key="/bser-damage-calculator">
          <NavLink to={"/bser-damage-calculator"}>데미지 계산기</NavLink>
        </Menu.Item>
        <Menu.Item key="/bser-live-assist">
          <NavLink to={"/bser-live-assist"}>화면 도우미</NavLink>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.SubMenu key="bser-esther" title="에스더 메뉴">
        <Menu.Item key="/bser-esther">
          <NavLink to={"/bser-esther"}>에스더 파티</NavLink>
        </Menu.Item>
        <Menu.Item key="/bser-esther-individual">
          <NavLink to={"/bser-esther-individual"}>에스더 개인</NavLink>
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
}

function MobileMenu({ onClick }) {
  const location = useLocation();
  return (
    <Menu mode="inline" selectedKeys={[location.pathname]} onClick={onClick}>
      <Menu.ItemGroup title={"통계"}>
        <Menu.Item key={"/bser-top-ranker"}>
          <NavLink to={"/bser-top-ranker"}>Top Ranker</NavLink>
        </Menu.Item>
        <Menu.Item key={"/bser-team-comp"}>
          <NavLink to={"/bser-team-comp"}>팀 조합</NavLink>
        </Menu.Item>
        <Menu.Item key={"/bser-damage-calculator"}>
          <NavLink to={"/bser-damage-calculator"}>데미지 계산기</NavLink>
        </Menu.Item>
        <Menu.Item key={"/bser-live-assist"}>
          <NavLink to={"/bser-live-assist"}>화면 도우미</NavLink>
        </Menu.Item>
      </Menu.ItemGroup>
      <Menu.ItemGroup title={"에스더 메뉴"}>
        <Menu.Item key={"/bser-esther"}>
          <NavLink to={"/bser-esther"}>에스더 파티</NavLink>
        </Menu.Item>
        <Menu.Item key={"/bser-esther-individual"}>
          <NavLink to={"/bser-esther-individual"}>에스더 개인</NavLink>
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );
}

function LostArkMenu() {
  const location = useLocation();
  return (
    <Menu
      mode="horizontal"
      selectedKeys={[location.pathname]}
      style={{ lineHeight: '62px', borderBottom: 'none', flexGrow: 1 }}
      theme="light"
    >
      <Menu.Item key="/lostark-party">
        <NavLink to={"/lostark-party"}>파티 편성</NavLink>
      </Menu.Item>
      <Menu.Item key="/lostark-schedule">
        <NavLink to={"/lostark-schedule"}>시간표 조정</NavLink>
      </Menu.Item>
    </Menu>
  );
}

function LostArkMobileMenu({ onClick }) {
  const location = useLocation();
  return (
    <Menu mode="inline" selectedKeys={[location.pathname]} onClick={onClick}>
      <Menu.Item key="/lostark-party">
        <NavLink to={"/lostark-party"}>파티 편성</NavLink>
      </Menu.Item>
      <Menu.Item key="/lostark-schedule">
        <NavLink to={"/lostark-schedule"}>시간표 조정</NavLink>
      </Menu.Item>
    </Menu>
  );
}

function AppShell({ title, menu, mobileMenu, homePath, children }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobileState = window.innerWidth < 768;
      if (mobileState !== isMobile) {
        setIsMobile(mobileState);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile]);

  const toggleDrawer = () => setDrawerVisible(!drawerVisible);
  const closeDrawer = () => setDrawerVisible(false);

  return (
    <Layout className='choco' style={{ minHeight: '100vh' }}>
      <Layout.Header
        style={{
          position: 'fixed',
          zIndex: 1001,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px',
          backgroundColor: '#fff',
          borderBottom: '1px solid #f0f0f0',
          height: '64px'
        }}
      >
        <Space align="center">
          {isMobile && (
            <AntButton
              type="text"
              icon={<MenuOutlined />}
              onClick={toggleDrawer}
              style={{ marginRight: 8 }}
            />
          )}
          {homePath && (
            <NavLink to={homePath} title="홈으로">
              <AntButton type="text" icon={<HomeOutlined />} />
            </NavLink>
          )}
          <Typography.Title level={4} style={{ margin: 0, whiteSpace: 'nowrap' }}>
            {title}
          </Typography.Title>
        </Space>

        {!isMobile && menu}
      </Layout.Header>

      {isMobile && (
        <Drawer
          title="메뉴"
          placement="left"
          onClose={closeDrawer}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          {homePath && (
            <Menu mode="inline">
              <Menu.Item key={homePath} onClick={closeDrawer}>
                <NavLink to={homePath}>홈으로</NavLink>
              </Menu.Item>
            </Menu>
          )}
          {React.cloneElement(mobileMenu, { onClick: closeDrawer })}
        </Drawer>
      )}

      <Layout.Content className='choco' style={{ padding: '24px', marginTop: 64 }}>
        <div style={{ padding: 24, minHeight: `calc(100vh - 64px - 48px - 48px)` }}>
          {children}
        </div>
      </Layout.Content>
    </Layout>
  );
}

function App() {
  const location = useLocation();
  const isMain = location.pathname === '/main';
  const isGame = location.pathname === '/game';
  const isHiddenMain = location.pathname === '/hidden/main';
  const isLostArk = location.pathname.startsWith('/lostark-');
  const isBlog = location.pathname === '/blog' || location.pathname.startsWith('/blog/');

  if (isMain) {
    return (
      <Routes>
        <Route path="/main" element={<Hub />} />
      </Routes>
    );
  }

  if (isGame) {
    return (
      <Routes>
        <Route path="/game" element={<GameHub />} />
      </Routes>
    );
  }

  if (isHiddenMain) {
    return (
      <Routes>
        <Route path="/hidden/main" element={<HiddenHub />} />
      </Routes>
    );
  }

  if (isLostArk) {
    return (
      <AppShell title="로스트아크" menu={<LostArkMenu />} mobileMenu={<LostArkMobileMenu />} homePath="/hidden/main">
        <Routes>
          <Route path={"/lostark-party"} element={<LostArkParty />} />
          <Route path={"/lostark-schedule"} element={<LostArkSchedule />} />
        </Routes>
      </AppShell>
    );
  }

  if (isBlog) {
    return (
      <Routes>
        <Route path={"/blog"} element={<BlogListPage />} />
        <Route path={"/blog/:slug"} element={<BlogPostPage />} />
      </Routes>
    );
  }

  return (
    <AppShell title="CHOCO WEB" menu={<PcMenu />} mobileMenu={<MobileMenu />} homePath="/main">
      <Routes>
        <Route path={"/login"} element={<LoginApp />} />
        <Route path={"/signup"} element={<Signup />} />
        <Route path={"/"} element={<Main />} />
        <Route path={"/bser-top-ranker"} element={<TopRanker />} />
        <Route path={"/bser-esther"} element={<EstherStat />} />
        <Route path={"/bser-esther-individual"} element={<EstherIndividualStat />} />
        <Route path={"/bser/character-stats"} element={<CharacterStats />} />
        <Route path={"/bser/route-detail"} element={<RouteDetail />} />
        <Route path={"/bser-team-comp"} element={<TeamComp />} />
        <Route path={"/bser-damage-calculator"} element={<DamageCalculator />} />
        <Route path={"/bser-live-assist"} element={<LiveAssist />} />
      </Routes>
    </AppShell>
  );
}

export default App;

/* 하단은 로그인 후 메뉴들. 임시 비활성 */

// function TopHorizontalMainMenu() {
//   const location = useLocation();
//   return (
//     <Menu
//       mode="horizontal"
//       selectedKeys={[location.pathname]}
//       style={{ lineHeight: '62px', borderBottom: 'none', flexGrow: 1 }}
//       theme="light"
//     >
//       <Menu.Item key="/">
//         <NavLink to={"/"}>메인화면</NavLink>
//       </Menu.Item>
//       <Menu.SubMenu key="cashflow-group" title="가계부">
//         <Menu.Item key="/cash-flow">
//           <NavLink to={"/cash-flow"}>사용</NavLink>
//         </Menu.Item>
//         <Menu.Item key="/cash-flow/setting">
//           <NavLink to={"/cash-flow/setting"}>세팅</NavLink>
//         </Menu.Item>
//       </Menu.SubMenu>
//       <Menu.SubMenu key="bser-group" title="이터널 리턴">
//         <Menu.Item key="/bser-top-ranker">
//           <NavLink to={"/bser-top-ranker"}>Top Ranker</NavLink>
//         </Menu.Item>
//         <Menu.Item key="/bser-esther">
//           <NavLink to={"/bser-esther"}>에스더 파티</NavLink>
//         </Menu.Item>
//         <Menu.Item key="/bser-esther-individual">
//           <NavLink to={"/bser-esther-individual"}>에스더 개인</NavLink>
//         </Menu.Item>
//       </Menu.SubMenu>
//     </Menu>
//   );
// }

// function AppSigninInfo() {
//   const user = useSelector((state) => state.user)
//   return (
//     <Space direction="vertical" className="signin-info" style={{ width: '100%', padding: '10px 24px' }}>
//       <Space direction="horizontal">
//         <Typography>{user.username}</Typography>
//         <Tag size="small">{user.role}</Tag>
//       </Space>
//       <AntButton href="/logout" block>
//         로그아웃
//       </AntButton>
//     </Space>
//   );
// }

// function MainMenu({ onClick }) {
//   const location = useLocation();
//   return (
//     <>
//       <AppSigninInfo />
//       <Menu mode="inline" selectedKeys={[location.pathname]} onClick={onClick}>
//         <Menu.ItemGroup title="메인">
//           <Menu.Item key="/">
//             <NavLink to={"/"}>메인화면</NavLink>
//           </Menu.Item>
//         </Menu.ItemGroup>
//         <Menu.ItemGroup title="가계부">
//           <Menu.Item key="/cash-flow">
//             <NavLink to={"/cash-flow"}>사용</NavLink>
//           </Menu.Item>
//           <Menu.Item key="/cash-flow/setting">
//             <NavLink to={"/cash-flow/setting"}>세팅</NavLink>
//           </Menu.Item>
//         </Menu.ItemGroup>
//         <Menu.ItemGroup title={"이터널 리턴"}>
//           <Menu.Item key={"/bser-top-ranker"}>
//             <NavLink to={"/bser-top-ranker"}>Top Ranker</NavLink>
//           </Menu.Item>
//           <Menu.Item key={"/bser-esther"}>
//             <NavLink to={"/bser-esther"}>에스더 파티</NavLink>
//           </Menu.Item>
//           <Menu.Item key={"/bser-esther-individual"}>
//             <NavLink to={"/bser-esther-individual"}>에스더 개인</NavLink>
//           </Menu.Item>
//         </Menu.ItemGroup>
//         <MenuDivider />
//       </Menu>
//     </>
//   );
// }
